
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eqCNB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $6ZgEd = parcelRequire("6ZgEd");

/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 






var $cs1vW = parcelRequire("cs1vW");

var $1cfRh = parcelRequire("1cfRh");





var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");





var $cbc8g = parcelRequire("cbc8g");


var $k0gy8 = parcelRequire("k0gy8");

var $c5a0x = parcelRequire("c5a0x");


var $57SAZ = parcelRequire("57SAZ");





var $301rJ = parcelRequire("301rJ");


var $ajypD = parcelRequire("ajypD");

var $hEbxW = parcelRequire("hEbxW");


var $fcNX6 = parcelRequire("fcNX6");


var $h82at = parcelRequire("h82at");

const $2e834eb8afc43178$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    preferencesBtn: {
        id: "browser-storage-controls.consent-banner.preferences.button",
        defaultMessage: "Preferences"
    },
    onlyNecessaryBtn: {
        id: "browser-storage-controls.consent-banner.only-necessary.button",
        defaultMessage: "Only necessary"
    },
    acceptAllBtn: {
        id: "browser-storage-controls.consent-banner.accept-all.button",
        defaultMessage: "Accept all"
    },
    cookiesTrackingNotice: {
        id: "browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024",
        defaultMessage: "Atlassian cookies and tracking notice"
    },
    useCookiesDescription: {
        id: "browser-storage-controls.consent-banner.cookies-description.text",
        defaultMessage: "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}"
    },
    useCookiesDescriptionNoLink: {
        id: "browser-storage-controls.consent-banner.cookies-description.text.no.link",
        defaultMessage: "Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device."
    },
    successFlagTitle: {
        id: "browser-storage-controls.consent-banner.success-flag.title",
        defaultMessage: "Cookie preferences saved"
    },
    successFlagDescription: {
        id: "browser-storage-controls.consent-banner.success-flag.description",
        defaultMessage: "You can change this at any time in your Atlassian account."
    },
    successFlagDescriptionLocalOnly: {
        id: "browser-storage-controls.consent-banner.success-flag.description-local-only",
        defaultMessage: "Your preferences will only affect this site."
    },
    errorFlagTitle: {
        id: "browser-storage-controls.consent-banner.error-flag.title",
        defaultMessage: "We're unable to update the policy"
    },
    errorFlagDescription: {
        id: "browser-storage-controls.consent-banner.error-flag.description",
        defaultMessage: "Try again in a few minutes."
    }
});



var $3h5nY = parcelRequire("3h5nY");


var $8h50e = parcelRequire("8h50e");

/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 






var $hiS1z = parcelRequire("hiS1z");




var $eEA8O = parcelRequire("eEA8O");


var $ccHMk = parcelRequire("ccHMk");


var $c6GJD = parcelRequire("c6GJD");


var $cvXh8 = parcelRequire("cvXh8");





var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");


var $3gadb = parcelRequire("3gadb");


var $3XYs8 = parcelRequire("3XYs8");


const $d349969e53fd97b7$var$boxStylesBlueWithMinHeight = (0, $ecnYn.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.information',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $d349969e53fd97b7$var$boxStylesPurpleWithMinHeight = (0, $ecnYn.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $d349969e53fd97b7$var$noticeContainerStyles = (0, $ecnYn.xcss)({
    flexDirection: 'column'
});
const $d349969e53fd97b7$var$experimentContainerStyles = (0, $ecnYn.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $d349969e53fd97b7$var$inlineWrapperStylesStaticHeight = (0, $ecnYn.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $bWLcG.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $d349969e53fd97b7$var$buttonContainerStylesStaticHeight = (0, $ecnYn.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $bWLcG.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $d349969e53fd97b7$var$truncatedTextStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $d349969e53fd97b7$var$linkNoTruncateStyles = (0, $ecnYn.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $d349969e53fd97b7$var$smallMediumScreenContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $bWLcG.media).above.md]: {
        display: 'none'
    }
});
const $d349969e53fd97b7$var$largeScreenContainerStyles = (0, $ecnYn.xcss)({
    display: 'none',
    [(0, $bWLcG.media).above.md]: {
        display: 'block'
    }
});
const $d349969e53fd97b7$var$noop = ()=>{};
const $d349969e53fd97b7$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $3XYs8.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $d349969e53fd97b7$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $d349969e53fd97b7$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $d349969e53fd97b7$var$noop, onClickAcceptAll: onClickAcceptAll = $d349969e53fd97b7$var$noop, onClickPreferences: onClickPreferences = $d349969e53fd97b7$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $d349969e53fd97b7$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const isCookiesBannerExperimentEnabled = (0, $c6GJD.default).getExperimentValue('cookies_banner_redesign_experiment', 'isEnabled', false);
    const useNewAtlaskitButton = (0, $dh538.fg)('cookies_banner_use_new_atlaskit_button');
    const intl = (0, $1cfRh.default)();
    const displayedTextMap = (0, $42omo.useMemo)(()=>{
        return $d349969e53fd97b7$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $42omo.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $d349969e53fd97b7$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $42omo.useCallback)(()=>{
        const displayedTextAcceptAllMap = $d349969e53fd97b7$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: isCookiesBannerExperimentEnabled ? $d349969e53fd97b7$var$boxStylesPurpleWithMinHeight : $d349969e53fd97b7$var$boxStylesBlueWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            xcss: $d349969e53fd97b7$var$inlineWrapperStylesStaticHeight,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                    xcss: isCookiesBannerExperimentEnabled ? $d349969e53fd97b7$var$experimentContainerStyles : $d349969e53fd97b7$var$noticeContainerStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                xcss: $d349969e53fd97b7$var$smallMediumScreenContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                            ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).useCookiesDescriptionNoLink
                                        }),
                                        position: "top",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                                            xcss: $d349969e53fd97b7$var$truncatedTextStyles,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                                ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).useCookiesDescriptionNoLink,
                                                tagName: "span"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                        id: "cookiesTrackingNoticeLink",
                                        href: "https://www.atlassian.com/legal/cookies",
                                        target: "_blank",
                                        onClick: onClickTrackingNoticeLink,
                                        xcss: $d349969e53fd97b7$var$linkNoTruncateStyles,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                            ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).cookiesTrackingNotice
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $d349969e53fd97b7$var$largeScreenContainerStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).useCookiesDescription,
                                    tagName: "span",
                                    values: {
                                        linkToCookiesTrackingNotice: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                            id: "cookiesTrackingNoticeLink",
                                            href: "https://www.atlassian.com/legal/cookies",
                                            target: "_blank",
                                            onClick: onClickTrackingNoticeLink,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                                ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).cookiesTrackingNotice
                                            })
                                        })
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                    space: "space.100",
                    xcss: $d349969e53fd97b7$var$buttonContainerStylesStaticHeight,
                    children: useNewAtlaskitButton ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                testId: "preferences-button",
                                appearance: "subtle",
                                onClick: onClickPreferences,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).preferencesBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                testId: "only-necessary-button",
                                onClick: handleOnlyNecessaryClick,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).onlyNecessaryBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                testId: "accept-all-button",
                                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
                                onClick: handleAcceptAllClick,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).acceptAllBtn
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                testId: "preferences-button",
                                appearance: "subtle",
                                onClick: onClickPreferences,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).preferencesBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                testId: "only-necessary-button",
                                onClick: handleOnlyNecessaryClick,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).onlyNecessaryBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                testId: "accept-all-button",
                                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                                    color: "currentColor",
                                    spacing: "none",
                                    testId: "experiment-one-button-icon",
                                    label: ""
                                }),
                                onClick: handleAcceptAllClick,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $2e834eb8afc43178$export$a7357cdd1f0b0168).acceptAllBtn
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 



var $5HtxZ = parcelRequire("5HtxZ");




var $kfwMJ = parcelRequire("kfwMJ");





var $gqmdp = parcelRequire("gqmdp");








var $6gmJj = parcelRequire("6gmJj");


var $hvqgK = parcelRequire("hvqgK");


var $ccRXO = parcelRequire("ccRXO");

const $5b5892496ef44031$export$1a7f5824c34ba94b = (initialPreferences)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If our bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (initialPreferences === (0, $ccRXO.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
    // if the user has consented or not yet since we need to fetch, so show the banner
    return true;
    // Confluence the banner will render on the UI, so we should plan to render here too
    if (!initialPreferences || (0, $6gmJj.initialPreferencesAreMissing)(initialPreferences)) return true;
    // If prefetched data has a consentToken or the consents array is there and populated
    // we want to hide the banner, as the user has has made consents already.
    const prefetchedDataHasConsents = (0, $hvqgK.hasPrefetchedDataConsents)(initialPreferences);
    return !prefetchedDataHasConsents;
};


const $95512d3e414f3992$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions?.getCookie ? ssrOptions.getCookie((0, $301rJ.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if ((ssrOptions?.isSSR ?? (0, $kfwMJ.isSSR)()) || inFlowWhereBannerStateIsUnknown) // When coming from SSR, this hook will only execute once and won't update later
    // Instead, if we're on the server, have initial preference data with valid consents, don't render
    // On later checks (rehydration), this will always fail and skip to the normal rendering logic
    // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
    // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
    // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
    return (0, $5b5892496ef44031$export$1a7f5824c34ba94b)(initialPreferences);
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $95512d3e414f3992$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $42omo.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $42omo.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $42omo.useMemo)(()=>{
        return $95512d3e414f3992$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $c5a0x.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $95512d3e414f3992$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $5HtxZ.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if (ssrOptions?.isSSR ?? (0, $kfwMJ.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $95512d3e414f3992$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $95512d3e414f3992$export$2e2bcd8739ae039 = $95512d3e414f3992$var$useBannerVisibility;


const $28c0332a57618e36$var$SuccessWithIntl = (0, $cs1vW.default)(({ intl: intl })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: "browser-storage-controls.consent-banner.toast.success",
            defaultMessage: "Success"
        }),
        spacing: (0, $dh538.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $28c0332a57618e36$var$ErrorWithIntl = (0, $cs1vW.default)(({ intl: intl })=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: "browser-storage-controls.consent-banner.toast.error",
            defaultMessage: "Error"
        }),
        spacing: (0, $dh538.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $28c0332a57618e36$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, $l998X.jsx)($28c0332a57618e36$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $28c0332a57618e36$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, $l998X.jsx)($28c0332a57618e36$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $28c0332a57618e36$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter = 'commercial' })=>{
    const firstRender = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $c5a0x.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $ajypD.deleteCookie)((0, $301rJ.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('fedramp-consent-banner-perimeter-prop')) (0, $k0gy8.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
        else (0, $k0gy8.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $42omo.useState)(false);
    const intl = (0, $1cfRh.default)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $8h50e.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $95512d3e414f3992$export$2e2bcd8739ae039)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $42omo.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $42omo.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $42omo.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $c5a0x.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $42omo.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$28c0332a57618e36$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).successFlagTitle)
        });
        else showFlag({
            ...$28c0332a57618e36$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).successFlagDescription),
            title: intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            ...$28c0332a57618e36$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).errorFlagDescription),
            title: intl.formatMessage((0, $2e834eb8afc43178$export$a7357cdd1f0b0168).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $42omo.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $c5a0x.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $fcNX6.updatePreferences)((0, $301rJ.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $c5a0x.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $301rJ.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $42omo.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $c5a0x.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $fcNX6.updatePreferences)((0, $301rJ.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $c5a0x.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $301rJ.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $42omo.useCallback)(()=>{
        (0, $c5a0x.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $42omo.useEffect)(()=>{
        if (showBanner) (0, $cbc8g.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow?.();
        else if (!showBanner) onHide?.();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $42omo.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut?.();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $57SAZ.BSCIntlProvider), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $d349969e53fd97b7$export$dd3e60478510f81d), {
                    onClickOnlyNecessary: onClickOnlyNecessary,
                    onClickAcceptAll: onClickAcceptAll,
                    onClickPreferences: onClickPreferences,
                    onClickTrackingNoticeLink: onClickTrackingNoticeLink,
                    minWidth: minWidth,
                    newMinHeight: newMinHeight
                }),
                isPreferencesModalOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $3h5nY.PreferenceModal), {
                    onClose: closePreferenceModal,
                    onSubmit: onPreferenceModalSubmit,
                    showSuccessFlag: showSuccessFlag,
                    showErrorFlag: showErrorFlag,
                    shouldAddWrappers: false
                })
            ]
        })
    });
};


const $94a87b8b58ce632b$export$903b95b8397e77e9 = (props)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $dh538.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $42omo.useEffect)(()=>{
            onConsentBannerBailOut?.();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $6ZgEd.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $28c0332a57618e36$export$24af610f9b900e82), {
                ...props
            })
        })
    });
};
module.exports["ConsentBanner"] = $94a87b8b58ce632b$export$903b95b8397e77e9;

});

parcelRegister("3jCS7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $41d20f01b3b99b28$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $f3a0721ed99e0bf5$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify': 'Measures usage to improve app performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.strict.description.082624-appify': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-description.text.no.link': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved',
    'browser-storage-controls.consent-banner.toast.error': 'Error',
    'browser-storage-controls.consent-banner.toast.success': 'Success'
};


var $41d20f01b3b99b28$export$2e2bcd8739ae039 = (0, $f3a0721ed99e0bf5$export$2e2bcd8739ae039);

});

parcelRegister("i24yA", function(module, exports) {

let $d20bf2c8d8aa48b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d20bf2c8d8aa48b4$var$load("gCbq8").then(()=>parcelRequire('7rXEs'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("cgcnm", function(module, exports) {

let $8ed0943f4b4c657a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ed0943f4b4c657a$var$load("TR24h").then(()=>parcelRequire('bYpqK'));

});

parcelRegister("28BNH", function(module, exports) {

let $18e9a68485ed7a45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18e9a68485ed7a45$var$load("NfUyB").then(()=>parcelRequire('joLhc'));

});

parcelRegister("iAn4i", function(module, exports) {

let $d87d7ba671cb5b8f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d87d7ba671cb5b8f$var$load("4v21d").then(()=>parcelRequire('4OrDw'));

});

parcelRegister("kVZre", function(module, exports) {

let $f3d8c9dbd0e4cd3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3d8c9dbd0e4cd3f$var$load("4D2WV").then(()=>parcelRequire('fcatw'));

});

parcelRegister("8eqF1", function(module, exports) {

let $018bf0c55d91a550$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $018bf0c55d91a550$var$load("gSwbJ").then(()=>parcelRequire('lHvaz'));

});

parcelRegister("lRDs7", function(module, exports) {

let $fead26aec9f66494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fead26aec9f66494$var$load("chaHI").then(()=>parcelRequire('2HSAx'));

});

parcelRegister("eZ7ii", function(module, exports) {

let $ae8c6ba6f65afe3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae8c6ba6f65afe3e$var$load("kBpIt").then(()=>parcelRequire('55jU9'));

});

parcelRegister("aCN6h", function(module, exports) {

let $7bc38a47b47bf5b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bc38a47b47bf5b6$var$load("dPeMl").then(()=>parcelRequire('lvf7Q'));

});

parcelRegister("f2Do9", function(module, exports) {

let $af3598a787bddc26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af3598a787bddc26$var$load("4PHEa").then(()=>parcelRequire('9KAfh'));

});

parcelRegister("9hvfP", function(module, exports) {

let $6c1df20c90a60f3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c1df20c90a60f3b$var$load("CGYMd").then(()=>parcelRequire('dyppk'));

});

parcelRegister("jxti3", function(module, exports) {

let $e397d1cde7a932e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e397d1cde7a932e1$var$load("fGpBg").then(()=>parcelRequire('6vOy5'));

});

parcelRegister("e45Hi", function(module, exports) {

let $a3d5dbc4d28623c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3d5dbc4d28623c9$var$load("cgWNw").then(()=>parcelRequire('ethPs'));

});

parcelRegister("60aq2", function(module, exports) {

let $45ead3222b961c33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45ead3222b961c33$var$load("aUP3I").then(()=>parcelRequire('9DjFp'));

});

parcelRegister("42fQ1", function(module, exports) {

let $2f03a2722d81be14$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f03a2722d81be14$var$load("bs4gz").then(()=>parcelRequire('gYBzc'));

});

parcelRegister("kDihk", function(module, exports) {

let $f055a0e576613602$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f055a0e576613602$var$load("gSXrz").then(()=>parcelRequire('dQrkK'));

});

parcelRegister("fqwMa", function(module, exports) {

let $b3b2b5585617fc0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b3b2b5585617fc0d$var$load("aJd4I").then(()=>parcelRequire('gZXwW'));

});

parcelRegister("c6PCW", function(module, exports) {

let $8d0e17a6bb81a170$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d0e17a6bb81a170$var$load("aJd4I").then(()=>parcelRequire('ixNSY'));

});

parcelRegister("idlH1", function(module, exports) {

let $d42a44a54aa0ea2b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d42a44a54aa0ea2b$var$load("aJd4I").then(()=>parcelRequire('5JgVu'));

});

parcelRegister("obQng", function(module, exports) {

let $048b6ded4341a142$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $048b6ded4341a142$var$load("aJd4I").then(()=>parcelRequire('e7GbG'));

});

parcelRegister("eWZ3k", function(module, exports) {

let $ae25d73e06d859a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae25d73e06d859a9$var$load("gR7fm").then(()=>parcelRequire('jwf4n'));

});

parcelRegister("lJVZH", function(module, exports) {

let $fd3ac95971a7cc54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd3ac95971a7cc54$var$load("xDkFq").then(()=>parcelRequire('7OZkg'));

});

parcelRegister("9aX21", function(module, exports) {

let $6ae2d6ab0e7b6ef0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ae2d6ab0e7b6ef0$var$load("cV2OA").then(()=>parcelRequire('c66Q0'));

});

parcelRegister("3J91m", function(module, exports) {

let $2b6c92718dd9a91f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2b6c92718dd9a91f$var$load("ehLR6").then(()=>parcelRequire('1KMTF'));

});

parcelRegister("6hROW", function(module, exports) {

let $493e1441085df0c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $493e1441085df0c4$var$load("lXmbw").then(()=>parcelRequire('1DcG0'));

});

parcelRegister("jkNuY", function(module, exports) {

let $e13647fa45fc90c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e13647fa45fc90c3$var$load("jwfyA").then(()=>parcelRequire('kmhQX'));

});

parcelRegister("3BLRV", function(module, exports) {

let $2a09f58fccc8e3b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a09f58fccc8e3b0$var$load("6zOB9").then(()=>parcelRequire('A5CaT'));

});

parcelRegister("3h5nY", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $c5a0x = parcelRequire("c5a0x");


var $57SAZ = parcelRequire("57SAZ");


var $6ZgEd = parcelRequire("6ZgEd");


var $301rJ = parcelRequire("301rJ");


var $fcNX6 = parcelRequire("fcNX6");








var $hiS1z = parcelRequire("hiS1z");

var $1cfRh = parcelRequire("1cfRh");


var $eEA8O = parcelRequire("eEA8O");


var $fzqvY = parcelRequire("fzqvY");


var $cO1el = parcelRequire("cO1el");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $6xdDU = parcelRequire("6xdDU");

var $804cB = parcelRequire("804cB");





var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $3XYs8 = parcelRequire("3XYs8");


var $ccRXO = parcelRequire("ccRXO");








var $7gpC4 = parcelRequire("7gpC4");

















const $12d4e04e6c765750$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $12d4e04e6c765750$var$categoryBoxStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.200'
});
const $12d4e04e6c765750$var$categoryDescriptionStyles = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $12d4e04e6c765750$var$categoryToEventSubjectMap = {
    [(0, $ccRXO.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $ccRXO.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $ccRXO.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $ccRXO.PreferenceCategory).Unknown]: null,
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: null
};
const $12d4e04e6c765750$var$categoryToTestIdMap = {
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $ccRXO.PreferenceCategory).Analytics]: 'analytics',
    [(0, $ccRXO.PreferenceCategory).Functional]: 'functional',
    [(0, $ccRXO.PreferenceCategory).Marketing]: 'marketing',
    [(0, $ccRXO.PreferenceCategory).Unknown]: null
};
const $12d4e04e6c765750$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $42omo.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $ccRXO.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $12d4e04e6c765750$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $c5a0x.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = (0, $dh538.fg)('cookies-modal-include-id-for-category-description') ? `consent-preference-${$12d4e04e6c765750$var$categoryToTestIdMap[category]}-description` : undefined;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $12d4e04e6c765750$var$categoryBoxStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
                className: `${$12d4e04e6c765750$var$tmpTrelloClassNameOverride}`,
                isChecked: isChecked,
                value: isChecked.toString(),
                onChange: onCheckboxChange,
                label: titleElement,
                name: `${titleString}`,
                testId: `consent-preference-${$12d4e04e6c765750$var$categoryToTestIdMap[category]}`,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $12d4e04e6c765750$var$categoryDescriptionStyles,
                id: descriptionId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: descriptionElement
                })
            })
        ]
    });
};



var $h82at = parcelRequire("h82at");

const $120c2b5a47a72db8$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    title: {
        id: "browser-storage-controls.consent-banner-modal.title",
        defaultMessage: "Cookie preferences"
    },
    summaryDescription: {
        id: "browser-storage-controls.consent-banner-modal.summary.description.082624",
        defaultMessage: "Because we value your privacy, you can select which cookies you allow. {link}"
    },
    strictDescription: {
        id: "browser-storage-controls.consent-banner-modal.strict.description.082624",
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits."
    },
    confirmBtn: {
        id: "browser-storage-controls.consent-banner-modal.confirm.button",
        defaultMessage: "Confirm"
    },
    cancelBtn: {
        id: "browser-storage-controls.consent-banner-modal.cancel.button",
        defaultMessage: "Cancel"
    },
    trackingLink: {
        id: "browser-storage-controls.consent-banner-modal.tracking.link.082624",
        defaultMessage: "Review our cookies and tracking notice"
    },
    functionalOption: {
        id: "browser-storage-controls.consent-banner-modal.functional.option.082624",
        defaultMessage: "Allow functional cookies"
    },
    functionalOptionDescription: {
        id: "browser-storage-controls.consent-banner-modal.functional.description.082624",
        defaultMessage: "Provides enhanced functionality and personalization."
    },
    analyticalOption: {
        id: "browser-storage-controls.consent-banner-modal.analytical.option.082624",
        defaultMessage: "Allow analytical cookies"
    },
    analyticalOptionDescription: {
        id: "browser-storage-controls.consent-banner-modal.analytical.description.101024",
        defaultMessage: "Measures usage to improve product performance."
    },
    marketingOption: {
        id: "browser-storage-controls.consent-banner-modal.marketing.option.082624",
        defaultMessage: "Allow marketing cookies"
    },
    marketingOptionDescription: {
        id: "browser-storage-controls.consent-banner-modal.marketing.description.082624",
        defaultMessage: "Used for targeted advertising."
    },
    strictDescriptionAppify: {
        id: "browser-storage-controls.consent-banner-modal.strict.description.082624-appify",
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits."
    },
    analyticalOptionDescriptionAppify: {
        id: "browser-storage-controls.consent-banner-modal.analytical.description.101024-appify",
        defaultMessage: "Measures usage to improve app performance."
    }
});


const $0e9b9b0ac3a85039$var$categoryNameStyles = (0, $ecnYn.xcss)({
    fontWeight: 'font.weight.bold'
});
const $0e9b9b0ac3a85039$var$customHeaderStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $0e9b9b0ac3a85039$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($0e9b9b0ac3a85039$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) {
        if (node.props.children) return $0e9b9b0ac3a85039$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $0e9b9b0ac3a85039$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $0e9b9b0ac3a85039$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $0e9b9b0ac3a85039$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $ccRXO.PreferenceCategory).Functional,
            title: (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).functionalOption,
            description: (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $ccRXO.PreferenceCategory).Analytics,
            title: (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).analyticalOption,
            description: (0, $dh538.fg)('product-terminology-refresh') ? (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).analyticalOptionDescriptionAppify : (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $ccRXO.PreferenceCategory).Marketing,
            title: (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).marketingOption,
            description: (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $3XYs8.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $0e9b9b0ac3a85039$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0e9b9b0ac3a85039$var$categoryNameStyles,
                children: translatedTitle
            }),
            descriptionElement: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: translatedDescription
            }),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $0e9b9b0ac3a85039$var$noop = ()=>{};
const $0e9b9b0ac3a85039$var$CustomHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $804cB.useModal)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $0e9b9b0ac3a85039$var$customHeaderStyles,
        padding: "space.300",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                onClick: onClose,
                testId: "close-modal-button"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                as: "h1",
                size: "medium",
                id: titleId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).title
                })
            })
        ]
    });
};
const $0e9b9b0ac3a85039$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $0e9b9b0ac3a85039$var$noop, onSubmit: onSubmit = $0e9b9b0ac3a85039$var$noop, onClose: onClose = $0e9b9b0ac3a85039$var$noop, setIsOpen: setIsOpen = $0e9b9b0ac3a85039$var$noop })=>{
    const intl = (0, $1cfRh.default)();
    const onCloseModal = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $42omo.useCallback)(()=>{
        onCloseModal();
        (0, $c5a0x.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $42omo.useCallback)(()=>{
        onCloseModal();
        (0, $c5a0x.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $42omo.useCallback)(()=>{
        onCloseModal();
        (0, $c5a0x.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $42omo.useCallback)(()=>{
        (0, $c5a0x.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $42omo.useMemo)(()=>{
        return $0e9b9b0ac3a85039$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $42omo.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            onClose: onClickBackground,
            children: (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
                onSubmit: handleSubmission,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($0e9b9b0ac3a85039$var$CustomHeader, {
                        onClose: onClickClose
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                        ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).summaryDescription,
                                        values: {
                                            link: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                target: "_blank",
                                                onClick: onClickTrackingNoticeLink,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                                    ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).trackingLink
                                                })
                                            })
                                        },
                                        tagName: 'p'
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                        ...(0, $dh538.fg)('product-terminology-refresh') ? (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).strictDescription,
                                        values: {
                                            bold: (msg)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                                    weight: "bold",
                                                    children: msg
                                                })
                                        },
                                        tagName: 'p'
                                    })
                                ]
                            }),
                            cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $12d4e04e6c765750$export$3c97a3b492e10ae9), {
                                        category: category,
                                        titleElement: titleElement,
                                        titleString: titleString,
                                        descriptionElement: description,
                                        isChecked: (preferences && preferences[category]) ?? false,
                                        setPreferencesData: setPreferencesData
                                    })
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                appearance: "subtle",
                                onClick: onClickCancel,
                                testId: "consent-preference-cancel",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).cancelBtn
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                type: "submit",
                                appearance: "primary",
                                onClick: handleSubmission,
                                testId: "consent-preference-confirm",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).confirmBtn
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                onSubmit: handleSubmission,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($0e9b9b0ac3a85039$var$CustomHeader, {
                                onClose: onClickClose
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                                ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).summaryDescription,
                                                values: {
                                                    link: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                                        href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                                                        target: "_blank",
                                                        onClick: onClickTrackingNoticeLink,
                                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                                            ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).trackingLink
                                                        })
                                                    })
                                                },
                                                tagName: 'p'
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                                ...(0, $dh538.fg)('product-terminology-refresh') ? (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).strictDescriptionAppify : (0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).strictDescription,
                                                values: {
                                                    bold: (msg)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                                            weight: "bold",
                                                            children: msg
                                                        })
                                                },
                                                tagName: 'p'
                                            })
                                        ]
                                    }),
                                    cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $12d4e04e6c765750$export$3c97a3b492e10ae9), {
                                                category: category,
                                                titleElement: titleElement,
                                                titleString: titleString,
                                                descriptionElement: description,
                                                isChecked: (preferences && preferences[category]) ?? false,
                                                setPreferencesData: setPreferencesData
                                            })
                                        }, index))
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                        appearance: "subtle",
                                        onClick: onClickCancel,
                                        testId: "consent-preference-cancel",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                            ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).cancelBtn
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                        type: "submit",
                                        appearance: "primary",
                                        onClick: handleSubmission,
                                        testId: "consent-preference-confirm",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                            ...(0, $120c2b5a47a72db8$export$a7357cdd1f0b0168).confirmBtn
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        })
    });
};



var $8h50e = parcelRequire("8h50e");

const $155675948ee01e00$export$94c5684831c222e7 = (props)=>{
    if ((0, $dh538.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $dh538.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($155675948ee01e00$export$30df3cfccbe10e6e, {
        ...props
    });
};
const $155675948ee01e00$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(true);
    const isEventSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $c5a0x.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $8h50e.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $301rJ.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $42omo.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $c5a0x.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $fcNX6.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $c5a0x.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag?.();
            } catch (e) {
                (0, $6ZgEd.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag?.();
            }
            setIsModalOpen(false);
            onSubmit?.();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag?.();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $0e9b9b0ac3a85039$export$9921ee7829a3ba4), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $301rJ.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: shouldAddWrappers ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $57SAZ.BSCIntlProvider), {
                children: modalContent
            })
        }) : modalContent
    });
};
module.exports["PreferenceModal"] = $155675948ee01e00$export$94c5684831c222e7;

});

parcelRegister("57SAZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $3jCS7 = parcelRequire("3jCS7");

var $hZOZi = parcelRequire("hZOZi");

const $68ba7eec9e2430cd$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $3jCS7.default),
        loaderFn: (0, $hZOZi.fetchMessagesForLocale),
        children: children
    });
};
module.exports["BSCIntlProvider"] = $68ba7eec9e2430cd$export$9aa38aed134c207f;

});

parcelRegister("fcNX6", function(module, exports) {

var $5HtxZ = parcelRequire("5HtxZ");


var $301rJ = parcelRequire("301rJ");


var $ccRXO = parcelRequire("ccRXO");


var $5smpe = parcelRequire("5smpe");


var $gqmdp = parcelRequire("gqmdp");


var $6gmJj = parcelRequire("6gmJj");

const $e069405dbd0f1d72$var$emptyDisplayedTextMap = {
    [(0, $ccRXO.PreferenceCategory).Analytics]: '',
    [(0, $ccRXO.PreferenceCategory).Functional]: '',
    [(0, $ccRXO.PreferenceCategory).Marketing]: '',
    [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $ccRXO.PreferenceCategory).Unknown]: ''
};
async function $e069405dbd0f1d72$export$7bb3e177c1a1e841(preferences, displayedTextMap = $e069405dbd0f1d72$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $5HtxZ.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $6gmJj.packUserPreferences)(preferences);
        (0, $gqmdp.setStrictlyNecessaryCookie)((0, $301rJ.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $5smpe.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}
module.exports["updatePreferences"] = $e069405dbd0f1d72$export$7bb3e177c1a1e841;

});

parcelRegister("3XYs8", function(module, exports) {

var $ccRXO = parcelRequire("ccRXO");

const $24e4efa4d28d53b4$export$99df83ca0f45bd54 = [
    (0, $ccRXO.PreferenceCategory).Analytics,
    (0, $ccRXO.PreferenceCategory).Functional,
    (0, $ccRXO.PreferenceCategory).Marketing,
    (0, $ccRXO.PreferenceCategory).StrictlyNecessary,
    (0, $ccRXO.PreferenceCategory).Unknown
];
module.exports["CONSENT_DISPLAYED_TEXT_ITEMS"] = $24e4efa4d28d53b4$export$99df83ca0f45bd54;

});

parcelRegister("8h50e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6gmJj = parcelRequire("6gmJj");


var $7MEbC = parcelRequire("7MEbC");


var $fcNX6 = parcelRequire("fcNX6");

/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $04788cc12c00b6b7$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $7MEbC.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $04788cc12c00b6b7$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
	 * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
	 *  during the initial render. Without this flag, the application might incorrectly display a banner based on
	 * incomplete or missing preference data. During the rehydration process, this initial render triggers
	 * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
	 * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
	 * and the client-rendered state.
	 */ const isInitialRender = (0, $42omo.useRef)(true);
    const prefetchedPreferencesData = (0, $42omo.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $42omo.useState)((0, $6gmJj.initializePreferencesData)(initialPreferences));
    (0, $42omo.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $6gmJj.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $fcNX6.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $04788cc12c00b6b7$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData?.prefs,
        isPrefetchedPreferencesState: preferencesData?.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $04788cc12c00b6b7$export$2e2bcd8739ae039 = $04788cc12c00b6b7$var$usePreferences;
module.exports["default"] = $04788cc12c00b6b7$export$2e2bcd8739ae039;

});

parcelRegister("hZOZi", function(module, exports) {

var $3jCS7 = parcelRequire("3jCS7");





























const $0a44e293f609857a$var$locales = {
    cs: ()=>(parcelRequire("i24yA")),
    da: ()=>(parcelRequire("cgcnm")),
    de: ()=>(parcelRequire("28BNH")),
    'en-GB': ()=>(parcelRequire("iAn4i")),
    'en-ZZ': ()=>(parcelRequire("kVZre")),
    en: ()=>Promise.resolve((parcelRequire("3jCS7"))),
    es: ()=>(parcelRequire("8eqF1")),
    fi: ()=>(parcelRequire("lRDs7")),
    fr: ()=>(parcelRequire("eZ7ii")),
    hu: ()=>(parcelRequire("aCN6h")),
    it: ()=>(parcelRequire("f2Do9")),
    ja: ()=>(parcelRequire("9hvfP")),
    ko: ()=>(parcelRequire("jxti3")),
    nb: ()=>(parcelRequire("e45Hi")),
    nl: ()=>(parcelRequire("60aq2")),
    pl: ()=>(parcelRequire("42fQ1")),
    'pt-BR': ()=>(parcelRequire("kDihk")),
    ru: ()=>(parcelRequire("fqwMa")),
    sl: ()=>(parcelRequire("c6PCW")),
    sr_RS: ()=>(parcelRequire("idlH1")),
    sr_YR: ()=>(parcelRequire("obQng")),
    sv: ()=>(parcelRequire("eWZ3k")),
    th: ()=>(parcelRequire("lJVZH")),
    tr: ()=>(parcelRequire("9aX21")),
    uk: ()=>(parcelRequire("3J91m")),
    vi: ()=>(parcelRequire("6hROW")),
    zh_TW: ()=>(parcelRequire("jkNuY")),
    zh: ()=>(parcelRequire("3BLRV"))
};
const $0a44e293f609857a$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $0a44e293f609857a$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $0a44e293f609857a$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $0a44e293f609857a$export$2b153a2030b0feb2;

});

parcelRegister("5smpe", function(module, exports) {

var $6ZgEd = parcelRequire("6ZgEd");


var $6RCHl = parcelRequire("6RCHl");


var $hvqgK = parcelRequire("hvqgK");


var $ccRXO = parcelRequire("ccRXO");


var $iUc7J = parcelRequire("iUc7J");


var $6gmJj = parcelRequire("6gmJj");


var $iU1uz = parcelRequire("iU1uz");

const $eb68ef6360e0cead$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $6gmJj.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $hvqgK.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $iU1uz.onlySetFallbackIfDifferent)(consentToken);
    else (0, $iUc7J.setConsentTokenFallbackCookie)(consentToken);
    (0, $iUc7J.setConsentTokenCookie)(consentToken);
    (0, $iUc7J.setShouldShowBannerCookie)(consentToken);
};
const $eb68ef6360e0cead$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $hvqgK.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $hvqgK.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $6gmJj.packUserPreferences)({
        ...mergedPrefs,
        [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $6ZgEd.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $iU1uz.onlySetFallbackIfDifferent)(consentToken);
        (0, $iUc7J.setConsentTokenCookie)(consentToken);
        (0, $iUc7J.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $6ZgEd.Logger).error('Token failed to save');
    (0, $iU1uz.onlySetFallbackIfDifferent)(consentToken);
    (0, $iUc7J.setShouldShowBannerCookie)(consentToken);
};
const $eb68ef6360e0cead$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $iU1uz.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $6RCHl.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $eb68ef6360e0cead$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $eb68ef6360e0cead$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};
module.exports["setConsentToken"] = $eb68ef6360e0cead$export$fbf549fe6f0e91dc;

});

parcelRegister("iU1uz", function(module, exports) {

var $301rJ = parcelRequire("301rJ");


var $ccRXO = parcelRequire("ccRXO");


var $hEbxW = parcelRequire("hEbxW");


var $iUc7J = parcelRequire("iUc7J");


var $6gmJj = parcelRequire("6gmJj");

const $ab94be635abb0b7d$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $ccRXO.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $ccRXO.PreferenceCategory).StrictlyNecessary],
        [(0, $ccRXO.PreferenceCategory).Functional]: updatedPreferences[(0, $ccRXO.PreferenceCategory).Functional],
        [(0, $ccRXO.PreferenceCategory).Analytics]: updatedPreferences[(0, $ccRXO.PreferenceCategory).Analytics],
        [(0, $ccRXO.PreferenceCategory).Marketing]: updatedPreferences[(0, $ccRXO.PreferenceCategory).Marketing],
        [(0, $ccRXO.PreferenceCategory).Unknown]: updatedPreferences[(0, $ccRXO.PreferenceCategory).Unknown]
    };
};
const $ab94be635abb0b7d$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences?.[(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!consentPreferences?.[(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable];
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!consentPreferences?.[(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault];
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $ccRXO.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $ccRXO.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $ccRXO.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $ab94be635abb0b7d$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $6gmJj.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $301rJ.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$ab94be635abb0b7d$var$pruneLegacyProperties(updatedPreferences),
            ...$ab94be635abb0b7d$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $301rJ.DEFAULT_PREFERENCES),
            ...$ab94be635abb0b7d$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $301rJ.DEFAULT_PREFERENCES),
        ...$ab94be635abb0b7d$var$pruneLegacyProperties(updatedPreferences),
        ...$ab94be635abb0b7d$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $ab94be635abb0b7d$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $hEbxW.getCookie)((0, $301rJ.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $iUc7J.setConsentTokenFallbackCookie)(consentToken);
};
module.exports["mergeConsentUpdates"] = $ab94be635abb0b7d$export$c0214a364df3006f;
module.exports["onlySetFallbackIfDifferent"] = $ab94be635abb0b7d$export$a023a0b818522757;

});


//# sourceMappingURL=browser-storage-controls.f8958c2e.js.map
